module.exports = __webpack_public_path__ + "img/logo.85ad4de2.png";